export const AUTH_ENDPOINT = 'login'
export const FORGOT_PASSWORD_ENDPOINT = 'forgetPassword'
export const RESET_PASSWORD_ENDPOINT = 'resetPassword'
export const USERS_ENDPOINT = 'user'
export const USERS_SHOW_ENDPOINT = 'user/show'
export const USERS_SHOW_STATUS_ENDPOINT = 'user/qrStatus'
export const USERS_CREATE_ENDPOINT = 'user/create'
export const USERS_UPLOAD_FILE_ENDPOINT = 'user/upload'
export const USERS_DELETE_ENDPOINT = 'user/delete'
export const USERS_STATUS_ENDPOINT = 'user/statusUpdate'
export const USERS_EXPORT_ENDPOINT = 'user/export'
export const EVENTS_ENDPOINT = 'event'
export const EVENTS_CREATE_ENDPOINT = 'event/create'
export const EVENTS_UPDATE_ENDPOINT = 'event/update'
export const EVENTS_SHOW_ENDPOINT = 'event/show'
export const EVENTS_DELETE_ENDPOINT = 'event/delete'
export const NOTIFICATIONS_ENDPOINT = 'notification'
export const NOTIFICATIONS_CREATE_ENDPOINT = 'notification/create'
export const NOTIFICATIONS_UPDATE_ENDPOINT = 'notification/update'
export const NOTIFICATIONS_SHOW_ENDPOINT = 'notification/show'
export const NOTIFICATIONS_DELETE_ENDPOINT = 'notification/delete'
export const TEAMS_ENDPOINT = 'team'
export const TEAMS_CREATE_ENDPOINT = 'team'
export const TEAMS_UPDATE_ENDPOINT = 'team/update'
export const TEAMS_SHOW_ENDPOINT = 'team/show'
export const TEAMS_DELETE_ENDPOINT = 'team/delete'
export const ATTENDANCE_ENDPOINT = 'event/attendees'
export const ATTENDANCE_CREATE_ENDPOINT = 'attendance/create'
export const ATTENDANCE_UPDATE_ENDPOINT = 'attendance/update'
export const ATTENDANCE_SHOW_ENDPOINT = 'attendance/show'
export const ATTENDANCE_DELETE_ENDPOINT = 'attendance/delete'
